import React, { useState } from 'react';
import NavigationItem from './NavigationItem';
import { useSelector } from 'react-redux';

const NavBar = ({ links = [] }) => {};

const Navigation = () => {
  const contentLinks = useSelector((state) => state.navigation.contentLinks);
  const [links, setLinks] = useState(contentLinks);
  const [menuOpen, setMenuOpen] = useState(false);

  const handleOpenMenu = (openItem) => {
    const newLinks = links.map((link, i) => ({
      ...link,
      open: !link.open && i === openItem,
    }));
    setLinks(newLinks);
    setMenuOpen(newLinks.some((link) => link.open));
  };

  return (
    <>
      <React.StrictMode>
        <NavigationItem links={links} onMenuOpen={handleOpenMenu} />
        <div
          className={`navbar__backdrop ${
            menuOpen ? 'navbar__backdrop--menu-open' : ''
          }`}
          onClick={() => handleOpenMenu(-1)}
        ></div>
      </React.StrictMode>
    </>
  );
};

export default Navigation;
